import script from "./historyListFirst.vue?vue&type=script&setup=true&lang=ts"
export * from "./historyListFirst.vue?vue&type=script&setup=true&lang=ts"

import "./historyListFirst.vue?vue&type=style&index=0&id=22c1a3be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c1a3be"]])

export default __exports__